import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';
import { Dialog } from 'quasar';
import { Network } from '@capacitor/network';

import { GetVersion } from '@/helpers.js';

const integrations = [];
if (import.meta.env.VITE_NODE_ENV === 'production') {
  integrations.push(
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  );
  integrations.push(Sentry.browserTracingIntegration());
}

function initSentry(VueApp) {
  Sentry.init(
    {
      app: VueApp,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      release: GetVersion(), // Sourcemaps set on version, not release
      integrations,
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.1, // Records 10% of all user sessions
      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: 1.0, // Always record sessions where an error happens

      async beforeSend(event, hint) {
        console.error(event);
        console.error(hint.originalException || hint.syntheticException);
        const { connected } = await Network.getStatus();
        if (
          connected &&
          hint.originalException &&
          hint.originalException.message &&
          hint.originalException.message.toString() === 'Network Error'
        ) {
          Dialog.create({
            title: '📡 No Connection',
            message: `We're having trouble connecting to the servers at the moment. Try refreshing the page and try again.`,
            html: true,
            fullWidth: false,
          })
            .onOk(async () => {
              // Refresh page if they hit continue
              location.reload();
            })
            .onCancel(() => {});
        }

        return event;
      },
      environment: import.meta.env.VITE_NODE_ENV,
      tracesSampleRate: 1,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
      ],
    },
    SentryVue.init
  );
}

export { initSentry, Sentry };
